export default {
  blank: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/layouts/blank.vue").then(m => m.default || m),
  default: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/layouts/default.vue").then(m => m.default || m),
  master: () => import("/opt/atlassian/pipelines/agent/build/yvr.portal/portal/layouts/master.vue").then(m => m.default || m)
}